export const FORM_SESSIONS_STEPS = {
    GUEST_INFORMATION: 'guest-information',
    SESSION_REGISTRATION: 'session-registration',
};
